module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('popup', {
    attrs: {
      "height": "8rem"
    },
    on: {
      "on-hide": _vm.hidePopup
    },
    model: {
      value: (_vm.hideDescribe),
      callback: function($$v) {
        _vm.hideDescribe = $$v
      },
      expression: "hideDescribe"
    }
  }, [_c('div', {
    staticClass: "headPic border"
  }, [_c('img', {
    attrs: {
      "src": _vm.data.image_default_id,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("￥" + _vm._s(_vm.data.price))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.data.title)), (_vm.data.specLabel) ? _c('span', [_vm._v("(" + _vm._s(_vm.data.specLabel) + ")")]) : _vm._e(), (_vm.data.areaLimit) ? _c('span', [_vm._v("(限售湖北)")]) : _vm._e()])]), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-cuowu",
    on: {
      "click": _vm.hidePopup
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "year vux-1px-b"
  }, [_c('span', [_vm._v("年份")]), _vm._v(" "), _c('div', _vm._l((_vm.data.spec_desc[27]), function(item, index) {
    return _c('span', {
      class: {
        active: index == _vm.yearTabIndex
      },
      on: {
        "click": function($event) {
          _vm.tabYear(index)
        }
      }
    }, [_vm._v(_vm._s(item.spec_value))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "year rongl vux-1px-b"
  }, [_c('span', [_vm._v("容量")]), _vm._v(" "), _c('div', _vm._l((_vm.data.spec_desc[28]), function(item, index) {
    return (item) ? _c('span', {
      class: {
        active: index == _vm.capacityTabIndex
      },
      on: {
        "click": function($event) {
          _vm.tabCapacity(index)
        }
      }
    }, [_vm._v(_vm._s(item ? item.spec_value : ""))]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "year rongl "
  }, [_c('span', [_vm._v("数量")]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('p', {
    staticClass: "rem",
    on: {
      "click": _vm.rem
    }
  }, [_c('i', {
    staticClass: "iconfont icon-jian"
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.num))]), _vm._v(" "), _c('p', {
    staticClass: "add",
    on: {
      "click": _vm.add
    }
  }, [_c('i', {
    staticClass: "iconfont icon-jia"
  })])])]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.createOrder
    }
  }, [_vm._v("确定")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1c1b4ea"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Detail/ShoppCart.vue
// module id = 620
// module chunks = 0